import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Collapse } from '../../views/ts/components/Collapse';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { Carousel } from '../twig/modules/carousel';
import { Footer } from '../twig/components/Footer';
import { Video } from '../twig/modules/video';
/*(new Analytics()).init();*/
(new Footer()).init();
(new Carousel()).init();
(new Collapse()).init();
//(new Dropdown()).init();
(new LazyLoader()).init();
//(new ScrollSpy()).init();
(new Menu()).init();
(new Video()).init();
// Always at the end
(new CookiesConsent()).init();
